import { GQLClientResponse } from '@oolio-group/gql-client';
import { ApolloError } from '@apollo/client';

export function parseApolloError(error: ApolloError): string {
  if (!error) {
    return '';
  }

  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return error.graphQLErrors
      .map(({ message }) => {
        return message;
      })
      .join(', ');
  } else if (error.message) {
    return error.message;
  } else {
    return 'Network Error';
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noopHandler(): void {}
